if (!customElements.get('drp-looks')) {
  customElements.define('drp-looks', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.drp-looks__track');
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-look-open]');
        if (opener) {
          const dialog = document.getElementById(`LookDialog-${opener.dataset.lookOpen}`);
          if (!dialog || dialog.open) return;
          this.opener = opener;
          this.activeDialog = dialog;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
          const product = dialog.querySelector(`[data-piece="${opener.dataset.product}"]`);
          dialog.querySelectorAll('[data-piece]').forEach(item => item.classList.toggle('is-selected', item === product));
          if (product) product.scrollIntoView({ block: 'nearest' });
          else dialog.querySelector('.drp-look-dialog__products').scrollTop = 0;
        }
        if (event.target.closest('[data-look-close]')) this.activeDialog?.close();
        const step = event.target.closest('[data-step]');
        if (step) {
          const card = this.track.querySelector('.drp-look');
          this.track.scrollBy({ left: (card?.getBoundingClientRect().width || 300) * Number(step.dataset.step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.activeDialog = null;
          this.opener?.focus({ preventScroll: true });
        }, options);
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.classList.add('is-ready');
      this.update();
      this.prepareArchive();
    }
    prepareArchive() {
      const archive = this.querySelector('.drp-look--archive');
      if (!archive) return;
      this.archiveObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.archiveObserver.disconnect();
        this.loadArchive(archive);
      }, { root: this.track, rootMargin: '0px 600px', threshold: 0 });
      this.archiveObserver.observe(archive);
    }
    async loadArchive(archive) {
      try {
        const url = new URL(archive.href);
        // Keep the same draft when testing a theme preview.
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) return;
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const shown = [...this.track.querySelectorAll('[data-look-handle]')].map(card => card.dataset.lookHandle);
        const looks = [...page.querySelectorAll('.drp-looks--grid [data-look-handle]')];
        const last = looks.findIndex(card => card.dataset.lookHandle === shown.at(-1));
        const candidates = last >= 0 ? looks.slice(last + 1).concat(looks.slice(0, last)) : looks;
        const next = candidates.find(card => !shown.includes(card.dataset.lookHandle) && card.querySelector('.drp-look__image img'));
        if (!next || !this.isConnected) return;
        const image = next.querySelector('.drp-look__image img').cloneNode(true);
        image.alt = '';
        image.loading = 'eager';
        image.removeAttribute('fetchpriority');
        image.sizes = '(max-width: 768px) 60vw, 23vw';
        archive.querySelector('.drp-look__archive-media').prepend(image);
        archive.dataset.nextLookHandle = next.dataset.lookHandle;
      } catch (error) {
        // The explicit link remains usable without an image or network access.
        if (error.name !== 'AbortError') archive.dataset.imageUnavailable = 'true';
      }
    }
    update() {
      const cards = this.track.querySelectorAll('.drp-look:not(.drp-look--archive)');
      if (!cards.length) return;
      const index = Math.min(cards.length, Math.round(Math.abs(this.track.scrollLeft) / cards[0].getBoundingClientRect().width) + 1);
      const count = this.querySelector('.drp-looks__count');
      if (count) count.textContent = `${index} / ${cards.length}`;
      const prev = this.querySelector('[data-step="-1"]');
      const next = this.querySelector('[data-step="1"]');
      if (prev) prev.disabled = this.track.scrollLeft <= 2;
      if (next) next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      if (this.activeDialog) {
        this.activeDialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.activeDialog = null;
      }
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.archiveObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
